import {dynamicWrapper, createRoute} from '@/utils/core';

const routesConfig = app => ({
    path: '/homepage/manageOfGroup',
    title: '分组管理',
    component: dynamicWrapper(app, [import('./model/index')], () => import('./components/index'))
});

export default app => createRoute(app, routesConfig);
